import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import { DatePicker } from 'antd';

import LogisticsOrderModal from '../components/LogisticsOrderModal';
import {
  exportOrders,
  fetchAreas,
  fetchCustomerCateogries,
  fetchDeliveryStatuses,
  fetchLogisticLines,
  fetchLogisticOrders,
  fetchOrderStatuses,
  importOrders,
  updateBulkOrders,
  updateStatus,
} from '../services/ordersService';
import { useTranslation } from 'react-i18next';
import { showSuccessToast, showWarningToast } from '../../../utils/toastHelper';
import Loader from '../../../components/Loader';
import { usePermissions } from '../../../contexts/PermissionsContext';
import { convertTo12HourFormat, formatDate } from '../../../utils/dateUtils';
import ImportOrdersModal from '../components/ImportOrdersModal';
import Pagination from '../../../components/Pagination';
import { printLogisticTable } from '../../../utils/printUtils';
import { trimDecimalZero } from '../../../utils/commonUtils';
import dayjs from 'dayjs';
import BulkUpdateConfirmationModal from '../components/BulkUpdateConfirmationModal';
import FileNames from '../../../constants/fileNames';
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

export default function Logistics() {
  const { t } = useTranslation('Order');
  const [printLoading, setPrintLoading] = useState(false);

  const { permissions } = usePermissions();

  const deliveryDateFilter = ['1', '2', '3'];
  const [selectedOrdersEdit, setSelectedOrdersEdit] = useState('');
  const [modalActionType, setModalActionType] = useState(false);
  const [addModal, setAddEditModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [orders, setOrders] = useState([]);
  const [customerCategories, setCustomerCategories] = useState([]);
  const [logisticLines, setLogisticLines] = useState([]);
  const [areas, setAreas] = useState([]);

  const [deliveryStatuses, setDeliveryStatuses] = useState([]);
  // const [deliveryDateRangeFilter, setDeliveryDateRangeFilter] = useState([]);

  const [bulkDeliveryStatusAction, setBulkDeliveryStatusAction] = useState('');
  const [selectedOrders, setSelectedOrders] = useState(new Set());
  const [importLoading, setimportLoading] = useState(false);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [dateFilter, setDateFilter] = useState('');
  const [datePickerValue, setDatePickerValue] = useState(null);
  const [bulkFunctionForConfirmation, setBulkFunctionForConfirmation] =
    useState('');
  const [bulkUpdateConfirmationModal, setBulkUpdateConfirmationModal] =
    useState(false);
  const [bulkActionLoading, setBulkActionLoading] = useState(false);

  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 30,
  });
  const [filters, setFilters] = useState({
    customerCategories: [],
    logisticLines: [],
    areas: [],
    deliveryDateFilter: ['1'],
  });

  const defaultLogisticLineSet = useRef(false);

  const getDeliveryDateClass = (deliveryDateStr) => {
    const deliveryDate = dayjs(deliveryDateStr).startOf('day');
    const today = dayjs().startOf('day');
    const diff = deliveryDate.diff(today, 'day');

    if (diff === 0) return 'today';
    if (diff === 1) return 'today-1';
    if (diff === 2) return 'today-2';
    if (diff === 3) return 'today-3';
    if (diff < 0) return 'past';
    return '';
  };
  useEffect(() => {
    if (logisticLines.length > 0 && !defaultLogisticLineSet.current) {
      // Find the ID of "天霖國際有限公司"
      const skyFreshLine = logisticLines.find(
        (line) => line.name === '天霖國際有限公司'
      );
      if (skyFreshLine) {
        setFilters((prev) => ({
          ...prev,
          logisticLines: [skyFreshLine.id],
        }));
        defaultLogisticLineSet.current = true;
      }
    }
  }, [logisticLines]);
  useEffect(() => {
    fetchData(pagination.current_page);
  }, [pagination.current_page]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(1, 1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [
    searchQuery,
    filters,
    //  deliveryDateRangeFilter,
    dateFilter,
  ]);

  const handleModalSuccess = () => {
    setAddEditModal(false); // Close the modal
    fetchData(1, 1);
  };
  const openAddEditModal = (order = null) => {
    if (order) {
      setSelectedOrdersEdit(order);

      setModalActionType('Edit');
    } else {
      setSelectedOrdersEdit('');
      setModalActionType('Add');
    }
    setAddEditModal(true);
  };
  const updatePagination = (newPagination) => {
    if (!newPagination) return;

    console.log(
      'current page:',
      pagination.current_page,
      'current page from pagination :',
      newPagination.current_page
    );

    if (
      newPagination.current_page !== pagination.current_page ||
      newPagination.total !== pagination.total ||
      newPagination.last_page !== pagination.last_page ||
      newPagination.per_page !== pagination.per_page
    ) {
      setPagination({
        total: newPagination.total,
        current_page: newPagination.current_page,
        last_page: newPagination.last_page,
        per_page: newPagination.per_page,
      });
    }
  };
  const fetchData = async (page = 1, ifSearch = 0) => {
    setLoading(true);
    try {
      const per_page = 50;
      const query = {
        page,
        per_page,
        search: searchQuery,
        customerCategories: filters.customerCategories,
        logisticLines: filters.logisticLines,
        areas: filters.areas,
        deliveryDateFilter: filters.deliveryDateFilter,
        // deliveryDateFilter: filters.deliveryDateFilter.length
        //   ? [...new Set([0, ...filters.deliveryDateFilter])]
        //   : [],
        // deliveryDateRangeFilter,
        date: dateFilter,
      };
      if (ifSearch) {
        const ordersResponse = await fetchLogisticOrders(query);
        if (ordersResponse.orders) {
          setOrders(ordersResponse.orders);
        }

        updatePagination(ordersResponse.pagination);
      } else {
        const [
          ordersResponse,
          orderStatusesResponse,
          customerCategoriesResponse,
          logisticLinesResponse,
          areasResponse,
          deliveryStatusesResponse,
        ] = await Promise.all([
          fetchLogisticOrders(query),
          fetchOrderStatuses(),
          fetchCustomerCateogries(),
          fetchLogisticLines(),
          fetchAreas(),
          fetchDeliveryStatuses(),
        ]);
        if (ordersResponse.orders) {
          setOrders(ordersResponse.orders);
        }
        if (orderStatusesResponse.order_statuses) {
          setOrderStatuses(orderStatusesResponse.order_statuses);
        }
        if (customerCategoriesResponse.customer_categories) {
          setCustomerCategories(customerCategoriesResponse.customer_categories);
        }
        if (logisticLinesResponse.logistic_lines) {
          // Move "天霖國際有限公司" to the first position if it exists
          const lines = [...logisticLinesResponse.logistic_lines];
          const skyFreshIndex = lines.findIndex(
            (line) => line.name === '天霖國際有限公司'
          );

          if (skyFreshIndex > -1) {
            // Remove from current position and add to the beginning
            const skyFreshLine = lines.splice(skyFreshIndex, 1)[0];
            lines.unshift(skyFreshLine);
          }

          setLogisticLines(lines);
        }
        if (areasResponse.areas) {
          setAreas(areasResponse.areas);
        }
        if (deliveryStatusesResponse.delivery_statuses) {
          setDeliveryStatuses(deliveryStatusesResponse.delivery_statuses);
        }

        updatePagination(ordersResponse.pagination);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPrintOrders = async () => {
    const per_page = 999999;
    const query = {
      per_page,
      search: searchQuery,
      customerCategories: filters.customerCategories,
      logisticLines: filters.logisticLines,
      areas: filters.areas,
      deliveryDateFilter: filters.deliveryDateFilter,
      // deliveryDateFilter: filters.deliveryDateFilter.length
      //   ? [...new Set([0, ...filters.deliveryDateFilter])]
      //   : [],
      date: dateFilter,
    };

    try {
      const ordersResponse = await fetchLogisticOrders(query);
      if (ordersResponse.orders) {
        return ordersResponse.orders;
      }
      return false;
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      return false;
    }
  };

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagination.last_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: pageNumber,
      }));
    }
  };

  const handleStatusChange = async (
    orderId,
    newStatus,
    field = 'delivery_status'
  ) => {
    const dataToSend = { orderId };

    if (field === 'status') {
      dataToSend.status_id = newStatus;
    } else if (field === 'delivery_status') {
      dataToSend.delivery_status_id = newStatus;
    }
    const response = await updateStatus(dataToSend, orderId);
    if (response.success) {
      // setOrders((prevOrders) =>
      //   prevOrders.map((order) =>
      //     order.id === orderId ? response.order : order
      //   )
      // );
      fetchData(pagination.current_page, 1);
    }
  };
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allItemsId = orders.map((order) => order.id);
      setSelectedOrders(new Set(allItemsId));
    } else {
      setSelectedOrders(new Set());
    }
  };
  const clearSelectFilter = (filterType) => {
    setFilters((prev) => {
      if (prev[filterType]?.length > 0) {
        return {
          ...prev,
          [filterType]: [],
        };
      }
      return prev;
    });
  };

  const handleFilterChange = (filterType, value) => {
    // If trying to change date filter and datepicker has a value, prevent it
    if (filterType === 'deliveryDateFilter' && dateFilter) {
      clearDateFilter();

      // showWarningToast(t('PLEASE_CLEAR_DATE_FILTERS_FIRST'));
      // return;
    }

    setFilters((prev) => {
      const newFilterState = { ...prev };
      if (value === 'ALL') {
        if (
          filterTypeData[filterType].length &&
          typeof filterTypeData[filterType][0] === 'object' &&
          'id' in filterTypeData[filterType][0]
        ) {
          newFilterState[filterType] =
            newFilterState[filterType].length ===
            filterTypeData[filterType].length
              ? [] // Deselect all
              : filterTypeData[filterType].map((item) => item.id); // Select all
        } else {
          newFilterState[filterType] =
            newFilterState[filterType].length ===
            filterTypeData[filterType].length
              ? [] // Deselect all
              : [...filterTypeData[filterType]]; // Select all as-is
        }
      } else {
        newFilterState[filterType] = newFilterState[filterType].includes(value)
          ? newFilterState[filterType].filter((item) => item !== value) // Deselect the item
          : [...newFilterState[filterType], value]; // Select the item
      }

      return newFilterState;
    });
  };
  const handleDateFilterChange = (date, dateString) => {
    // Only allow datepicker selection if no checkbox is selected
    if (filters.deliveryDateFilter.length !== 0) {
      clearSelectFilter('deliveryDateFilter');
      // showWarningToast(t('PLEASE_CLEAR_DATE_FILTERS_FIRST'));
      // return
    }
    setDateFilter(dateString);
    setDatePickerValue(date);
  };
  const clearDateFilter = () => {
    if (dateFilter !== '') setDateFilter('');
    if (datePickerValue !== null) setDatePickerValue(null);
  };

  const filterTypeData = {
    customerCategories: customerCategories,
    logisticLines: logisticLines,
    areas: areas,
    deliveryDateFilter: deliveryDateFilter,
  };
  const handleRowSelect = (e, id) => {
    const isChecked = e.target.checked;
    setSelectedOrders((prevSelected) => {
      const updatedSelection = new Set(prevSelected);
      if (isChecked) {
        updatedSelection.add(id);
      } else {
        updatedSelection.delete(id);
      }
      return updatedSelection;
    });
  };
  const openBulkUpdateConfirmationModal = (type) => {
    if (selectedOrders.size === 0) {
      showWarningToast(t('NOORDERSELECTED'));
      return;
    }
    if (type === 'deliveryStatus') {
      if (!bulkDeliveryStatusAction) {
        showWarningToast(t('PLEASESELECTANOPTIONTOPERFORM'));
        return;
      }
    }
    setBulkFunctionForConfirmation(type);
    setBulkUpdateConfirmationModal(true);
  };
  const onSuccessBulkUpdateConfirmation = async () => {
    await handleBulkActions(bulkFunctionForConfirmation);
    setBulkUpdateConfirmationModal(false);
  };
  const handleBulkActions = async (type) => {
    setBulkActionLoading(true);

    const selectedOrdersIds = Array.from(selectedOrders);
    const response = await updateBulkOrders({
      type,
      orders: selectedOrdersIds,
      action: bulkDeliveryStatusAction,
    });
    if (response.success) {
      showSuccessToast(response?.message || 'Success');
      fetchData(pagination.current_page, 1);
      setSelectedOrders(new Set());
      setBulkDeliveryStatusAction(null);
    }
    setBulkActionLoading(false);
  };
  const isAllSelected =
    orders.length > 0 && orders.every((order) => selectedOrders.has(order.id));
  const openImportModal = (order) => {
    setImportModal(true);
  };
  const handleImportOrders = async (formData) => {
    setimportLoading(true);
    const response = await importOrders(formData);
    setimportLoading(false);
    fetchData(1, 0);
    return response;
  };
  const isSingleDateSelected = (deliveryDateFilter, dateFilter) => {
    const hasOneDeliveryDate =
      Array.isArray(deliveryDateFilter) && deliveryDateFilter.length === 1;
    const hasDate = dateFilter.trim() !== '';
    return (hasOneDeliveryDate && !hasDate) || (!hasOneDeliveryDate && hasDate);
  };
  const getSelectedDeliveryDate = (deliveryDateFilter, dateFilter) => {
    if (Array.isArray(deliveryDateFilter) && deliveryDateFilter.length === 1) {
      const daysToAdd = parseInt(deliveryDateFilter[0], 10);
      const date = new Date();
      date.setDate(date.getDate() + daysToAdd);
      return formatDate(date);
    }

    if (typeof dateFilter === 'string' && dateFilter.trim() !== '') {
      const date = new Date(dateFilter);
      if (!isNaN(date)) {
        return formatDate(date);
      }
    }

    return null;
  };

  const handleExportOrders = async () => {
    if (!isSingleDateSelected(filters.deliveryDateFilter, dateFilter)) {
      showWarningToast(t('PLEASESELECTONLYONEDELIVERYDATE'));
      return;
    }
    const data = {
      search: searchQuery,
      customerCategories: filters.customerCategories,
      logisticLines: filters.logisticLines,
      areas: filters.areas,
      deliveryDateFilter: filters.deliveryDateFilter,
      // deliveryDateFilter: filters.deliveryDateFilter.length
      //   ? [...new Set([0, ...filters.deliveryDateFilter])]
      //   : [],
      // deliveryDateRangeFilter,
      date: dateFilter,
      type: 'LOGISTICS',
    };

    if (selectedOrders.size !== 0) {
      const selectedOrdersIds = Array.from(selectedOrders);

      data.selectedOrders = selectedOrdersIds;
    }

    const response = await exportOrders(
      data,
      FileNames.LOGISTICS_ORDERS_EXPORT
    );
  };

  const handlePrint = async () => {
    if (!isSingleDateSelected(filters.deliveryDateFilter, dateFilter)) {
      showWarningToast(t('PLEASESELECTONLYONEDELIVERYDATE'));

      return;
    }
    const deliveryDate = getSelectedDeliveryDate(
      filters.deliveryDateFilter,
      dateFilter
    );

    setPrintLoading(true);
    let printOrdersData;
    if (selectedOrders.size === 0) {
      printOrdersData = await fetchPrintOrders();
      if (!printOrdersData) {
        showWarningToast(t('NORECORDAVAILABLE'));
        return;
      }
    } else {
      printOrdersData = orders.filter((order) => selectedOrders.has(order.id));
    }

    const headers = [
      // [t('DELIVERYDATE'), deliveryDate],
      // [
      t('DELIVERYDATE'),
      t('REFERENCENUMBER'),
      t('CUSTOMERCATEGORY'),
      t('CUSTOMERCODE'),
      t('CUSTOMERNAME'),
      // t('CUSTOMERINFO'),
      t('DELIVERYADDRESS'),
      t('DISTRICT'),
      t('PRODUCTNAME'),
      t('PRODUCTREMARK'),
      t('QUANTITY'),
      t('PAYMENTMETHOD'),
      t('EARLIESTDELIVERYTIME'),
      t('LATESTDELIVERYTIME'),
      t('CONTACTPERSONINFO'),
      t('ORDERREMARK'),
      // t('UPDATEDELIVERYSTATUS'),
      // ],
    ];

    const content = [];
    const startGroup = [];
    const endGroup = [];
    printOrdersData.forEach((order, orderIndex) => {
      // Filter out products with 0 quantity
      const validProducts =
        order.products?.filter((product) => Number(product.quantity) > 0) || [];

      if (validProducts.length === 0) return; // Skip orders with no valid products

      // if (validProducts.length === 0) {
      // content.push([
      //   order.reference_number || '',
      //   order.delivery_date || '',
      //   order?.customer_group?.customer_category?.name ||
      //     order?.customer_category?.name ||
      //     '',
      //   (order.customer?.name || '') + ' ' + (order.customer?.code || ''),
      //   order.delivery_address || '',
      //   '', // No product name
      //   '', // No product remark
      //   '', // No quantity
      //   order.district?.name || '',
      //   order.payment_method?.name || '',
      //   convertTo12HourFormat(order.earliest_delivery_time) || '--:--',
      //   convertTo12HourFormat(order.latest_delivery_time) || '--:--',
      //   (order.contact_name || '') + ' ' + (order.contact_phone || ''),
      //   order.remark || '',
      // ]);
      // } else {

      validProducts.forEach((product, index) => {
        if (index === 0) {
          startGroup.push(content.length);
          endGroup.push(content.length - 1);
        }
        content.push([
          index === 0 ? order.delivery_date || '' : '',
          index === 0 ? order.reference_number || '' : '',
          index === 0
            ? order?.customer_group?.customer_category?.name ||
              order?.customer_category?.name ||
              ''
            : '',
          // index === 0
          //   ? (order.customer?.name || '') + ' ' + (order.customer?.code || '')
          //   : '',
          index === 0 ? order.customer?.code || '' : '',
          index === 0 ? order.customer?.name || '' : '',
          index === 0 ? order.delivery_address || '' : '',
          index === 0 ? order.district?.name || '' : '',
          product.product_name || '',
          product.remarks || '',
          trimDecimalZero(product.quantity?.toString()) || '',
          index === 0 ? order.payment_method?.name || '' : '',
          index === 0
            ? convertTo12HourFormat(order.earliest_delivery_time) || '--:--'
            : '',
          index === 0
            ? convertTo12HourFormat(order.latest_delivery_time) || '--:--'
            : '',
          index === 0
            ? (order.contact_name || '') + ' ' + (order.contact_phone || '')
            : '',
          index === 0 ? order.remark || '' : '',
        ]);
      });
      // }
    });

    printLogisticTable(
      headers,
      content,
      t('LOGISTICSORDERS'),
      setPrintLoading,
      startGroup,
      endGroup
    );
  };

  return (
    <main className="logistics homepage">
      <section className="main-section main-section-rs fbz-container-set">
        <section className="data">
          <div className="data on-responsive-block">
            <div className="row">
              <div className="col-sm-12 col-xl-3 col-md-12">
                <div className="left">
                  <h1>{t('LOGISTICS')} </h1>
                  <div className="input-div">
                    <div className="input-card">
                      <img src="images/search-icon.svg" alt="" />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder={t('SEARCH')}
                      />
                    </div>
                    <div className="filter-section date">
                      <label>{t('DELIVERYDATE')}</label>

                      <div className="date-picker range-picker">
                        <DatePicker
                          onChange={handleDateFilterChange}
                          value={datePickerValue}
                          placeholder={t('SELECTDATE')}
                          format={dateFormat}
                        />
                      </div>
                    </div>
                    {/* <div className="status">
                    {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <div className="order-status ">
                        <h3>{t('DELIVERYSTATUS')} </h3>
                        <div className="order-card ">
                          {deliveryStatuses.map((deliveryStatus) => (
                            <label
                              key={deliveryStatus.id}
                              className="container"
                            >
                              {deliveryStatus.name}

                              <input
                                type="checkbox"
                                checked={
                                  bulkDeliveryStatusAction ===
                                  deliveryStatus.name
                                }
                                onChange={() =>
                                  setBulkDeliveryStatusAction(
                                    bulkDeliveryStatusAction ===
                                      deliveryStatus.name
                                      ? null
                                      : deliveryStatus.name
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                          <button
                            className="update"
                            // onClick={() => handleBulkAction('deliveryStatus')}
                            onClick={() =>
                              openBulkUpdateConfirmationModal('deliveryStatus')
                            }
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </div>
                    )}
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xl-5 col-sm-12">
                <div className="right">
                  <div className="filter-container">
                    <div className="filter-section">
                      <label>{t('DELIVERYDATE')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.deliveryDateFilter.length ===
                              deliveryDateFilter.length
                            }
                            onChange={() =>
                              handleFilterChange('deliveryDateFilter', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {deliveryDateFilter.map((day, i) => (
                          <label key={i} className="custom-checkbox">
                            {t('TODAY')} +{day}
                            <input
                              type="checkbox"
                              checked={filters.deliveryDateFilter.includes(day)}
                              onChange={() =>
                                handleFilterChange('deliveryDateFilter', day)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="filter-section">
                      <label>{t('CUSTOMERCATEGORY')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.customerCategories.length ===
                              customerCategories.length
                            }
                            onChange={() =>
                              handleFilterChange('customerCategories', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {customerCategories.map((customerCategory) => (
                          <label
                            key={customerCategory.id}
                            className="custom-checkbox"
                          >
                            {customerCategory.name}
                            <input
                              type="checkbox"
                              checked={filters.customerCategories.includes(
                                customerCategory.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'customerCategories',
                                  customerCategory.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="filter-section">
                      <label>{t('LOGISTICLINE')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.logisticLines.length ===
                              logisticLines.length
                            }
                            onChange={() =>
                              handleFilterChange('logisticLines', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {logisticLines.map((logisticLine) => (
                          <label
                            key={logisticLine.id}
                            className="custom-checkbox"
                          >
                            {logisticLine.name}
                            <input
                              type="checkbox"
                              checked={filters.logisticLines.includes(
                                logisticLine.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'logisticLines',
                                  logisticLine.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="filter-section">
                      <label>{t('AREA')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={filters.areas.length === areas.length}
                            onChange={() => handleFilterChange('areas', 'ALL')}
                          />
                          <span className="checkmark"></span>
                        </label>
                        {areas.map((area) => (
                          <label key={area.id} className="custom-checkbox">
                            {area.name}
                            <input
                              type="checkbox"
                              checked={filters.areas.includes(area.id)}
                              onChange={() =>
                                handleFilterChange('areas', area.id)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xl-4 col-sm-12">
                <div className="right right-change-cs">
                  <div className="filter-container">
                    <div className="button-group">
                      <button
                        className="add-btn"
                        onClick={() => {
                          openAddEditModal(null);
                        }}
                      >
                        + {t('ADD')}
                      </button>
                      {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                        ?.edit_permission === 1 && (
                        <button
                          onClick={() => {
                            openImportModal();
                          }}
                        >
                          <img src="images/import.svg" alt="" />
                          {t('IMPORT')}
                        </button>
                      )}
                      <button onClick={handleExportOrders}>
                        <img src="images/export.svg" alt="" />
                        {t('EXPORT')}
                      </button>
                      <button
                        className={`${printLoading ? 'disable-btn' : ''}`}
                        onClick={handlePrint}
                        disabled={printLoading}
                      >
                        {printLoading ? (
                          <span>{t('PRINTING')}...</span>
                        ) : (
                          <>
                            <img src="images/print.svg" alt="" />
                            {t('PRINT')}
                          </>
                        )}
                      </button>
                      {/* <button
                        className="add-btn"
                        onClick={() => {
                          openAddEditModal(null);
                        }}
                      >
                        + {t('ADD')}
                      </button> */}
                    </div>
                  </div>
                  <div className="status">
                    {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <div className="order-status ">
                        <h3>{t('DELIVERYSTATUS')} </h3>
                        <div className="order-card ">
                          {deliveryStatuses.map((deliveryStatus) => (
                            <label
                              key={deliveryStatus.id}
                              className="container"
                            >
                              {deliveryStatus.name}

                              <input
                                type="checkbox"
                                checked={
                                  bulkDeliveryStatusAction ===
                                  deliveryStatus.name
                                }
                                onChange={() =>
                                  setBulkDeliveryStatusAction(
                                    bulkDeliveryStatusAction ===
                                      deliveryStatus.name
                                      ? null
                                      : deliveryStatus.name
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                          <button
                            className="update"
                            // onClick={() => handleBulkAction('deliveryStatus')}
                            onClick={() =>
                              openBulkUpdateConfirmationModal('deliveryStatus')
                            }
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="col-sm-12 col-xl-5 col-md-12">
              <div className="left">
                <h1>{t('LOGISTICS')} </h1>
                <div className="input-div">
                  <div className="input-card">
                    <img src="images/search-icon.svg" alt="" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder={t('SEARCH')}
                    />
                  </div>
                  <div className="status">
                    {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <div className="order-status ">
                        <h3>{t('DELIVERYSTATUS')} </h3>
                        <div className="order-card ">
                          {deliveryStatuses.map((deliveryStatus) => (
                            <label
                              key={deliveryStatus.id}
                              className="container"
                            >
                              {deliveryStatus.name}

                              <input
                                type="checkbox"
                                checked={
                                  bulkDeliveryStatusAction ===
                                  deliveryStatus.name
                                }
                                onChange={() =>
                                  setBulkDeliveryStatusAction(
                                    bulkDeliveryStatusAction ===
                                      deliveryStatus.name
                                      ? null
                                      : deliveryStatus.name
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                          <button
                            className="update"
                            // onClick={() => handleBulkAction('deliveryStatus')}
                            onClick={() =>
                              openBulkUpdateConfirmationModal('deliveryStatus')
                            }
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div> */}
              {/* <div className="col-lg-12 col-xl-7 col-sm-12">
              <div className="right">
                <div className="filter-container"> */}
              {/* <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>
                    <div className="date-picker range-picker">
                      <RangePicker
                        onChange={handleDateFilterChange}
                        separator={'-'}
                        placeholder={[t('FROM'), t('TO')]}
                      />
                    </div>
                  </div> */}
              {/* <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>

                    <div className="date-picker range-picker">
                      <DatePicker
                        onChange={handleDateFilterChange}
                        value={datePickerValue}
                        placeholder={t('SELECTDATE')}
                        format={dateFormat}
                      />
                    </div>
                  </div> */}
              {/* <div className="filter-section">
                    <label>{t('DELIVERYDATE')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.deliveryDateFilter.length ===
                            deliveryDateFilter.length
                          }
                          onChange={() =>
                            handleFilterChange('deliveryDateFilter', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {deliveryDateFilter.map((day, i) => (
                        <label key={i} className="custom-checkbox">
                          {t('TODAY')} +{day}
                          <input
                            type="checkbox"
                            checked={filters.deliveryDateFilter.includes(day)}
                            onChange={() =>
                              handleFilterChange('deliveryDateFilter', day)
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="filter-section">
                    <label>{t('CUSTOMERCATEGORY')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.customerCategories.length ===
                            customerCategories.length
                          }
                          onChange={() =>
                            handleFilterChange('customerCategories', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {customerCategories.map((customerCategory) => (
                        <label
                          key={customerCategory.id}
                          className="custom-checkbox"
                        >
                          {customerCategory.name}
                          <input
                            type="checkbox"
                            checked={filters.customerCategories.includes(
                              customerCategory.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'customerCategories',
                                customerCategory.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="filter-section">
                    <label>{t('LOGISTICLINE')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.logisticLines.length ===
                            logisticLines.length
                          }
                          onChange={() =>
                            handleFilterChange('logisticLines', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {logisticLines.map((logisticLine) => (
                        <label
                          key={logisticLine.id}
                          className="custom-checkbox"
                        >
                          {logisticLine.name}
                          <input
                            type="checkbox"
                            checked={filters.logisticLines.includes(
                              logisticLine.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'logisticLines',
                                logisticLine.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="filter-section">
                    <label>{t('AREA')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={filters.areas.length === areas.length}
                          onChange={() => handleFilterChange('areas', 'ALL')}
                        />
                        <span className="checkmark"></span>
                      </label>
                      {areas.map((area) => (
                        <label key={area.id} className="custom-checkbox">
                          {area.name}
                          <input
                            type="checkbox"
                            checked={filters.areas.includes(area.id)}
                            onChange={() =>
                              handleFilterChange('areas', area.id)
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div> */}

              {/* <div className="button-group">
                    {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                      ?.edit_permission === 1 && (
                      <button
                        onClick={() => {
                          openImportModal();
                        }}
                      >
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                    )}
                    <button onClick={handleExportOrders}>
                      <img src="images/export.svg" alt="" />
                      {t('EXPORT')}
                    </button>
                    <button
                      className={`${printLoading ? 'disable-btn' : ''}`}
                      onClick={handlePrint}
                      disabled={printLoading}
                    >
                      {printLoading ? (
                        <span>{t('PRINTING')}...</span>
                      ) : (
                        <>
                          <img src="images/print.svg" alt="" />
                          {t('PRINT')}
                        </>
                      )}
                    </button>
                    <button
                      className="add-btn"
                      onClick={() => {
                        openAddEditModal(null);
                      }}
                    >
                      + {t('ADD')}
                    </button>
                  </div> */}
              {/* </div>
              </div>
            </div> */}
            </div>
          </div>
        </section>
        {/* <!-- Table start --> */}
        {/* <div
          className={`table-outer ${orders.length >= 1 && orders.length <= 3 ? 'scroll' : ''}`}
        > */}
        <div className="table-outer">
          <div className="table">
            <div className="table-header">
              <ul className="t-heading">
                <li className="t-checkbox">
                  <label className="container">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAllChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                </li>
                <li className="reference">
                  <h5>{t('REFERENCENUMBER')}</h5>
                </li>
                <li className="date">
                  <h5>{t('DELIVERYDATE')}</h5>
                </li>
                <li className="category">
                  <h5>
                    {t('CUSTOMER')} {t('CATEGORY')}
                  </h5>
                </li>
                <li className="info">
                  <h5>{t('CUSTOMERINFO')}</h5>
                </li>
                <li className="address">
                  <h5>{t('DELIVERYADDRESS')}</h5>
                </li>
                <li className="district">
                  <h5>{t('DISTRICT')}</h5>
                </li>
                <li className="name">
                  <h5>{t('PRODUCTNAME')}</h5>
                </li>
                <li className="remark">
                  <h5>{t('PRODUCTREMARK')}</h5>
                </li>
                <li className="quantity">
                  <h5>{t('QUANTITY')}</h5>
                </li>
                <li className="payment">
                  <h5>
                    {t('PAYMENT')} {t('METHOD')}
                  </h5>
                </li>
                <li className="earliest-time">
                  <h5>
                    {t('EARLIEST')} {t('DELIVERYTIME')}
                  </h5>
                </li>
                <li className="latest-time">
                  <h5>
                    {t('LATEST')} {t('DELIVERYTIME')}
                  </h5>
                </li>
                <li className="contact">
                  <h5>
                    {t('CONTACT')} {t('PERSONINFO')}
                  </h5>
                </li>
                <li className="order-remark">
                  <h5>{t('ORDERREMARK')}</h5>
                </li>
                <li className="update-delivery">
                  <h5>{t('UPDATEDELIVERYSTATUS')}</h5>
                </li>
                <li className="update-status">
                  <h5>{t('ORDERSTATUS')}</h5>
                </li>
                {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                  ?.edit_permission === 1 && (
                  <li className="action">
                    <h5>{t('ACTION')}</h5>
                  </li>
                )}
              </ul>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="table-body">
                  {orders.length === 0 ? (
                    <p className="text-center py-4">{t('NORECORDAVAILABLE')}</p>
                  ) : (
                    orders.map((order, index) => {
                      // Filter products with quantity > 0
                      const validProducts =
                        order.products?.filter(
                          (product) => Number(product.quantity) > 0
                        ) || [];

                      // If no valid products, don't render the order
                      if (validProducts.length === 0) return null;

                      return (
                        <ul
                          key={index}
                          className={`main-logitcs-list ${getDeliveryDateClass(order.delivery_date)}`}
                        >
                          {/* <!-- outer product --> */}
                          <div className="d-flex logitcs-flex align-items-center">
                            <li className="t-checkbox">
                              <label className="container">
                                <input
                                  type="checkbox"
                                  checked={selectedOrders.has(order.id)}
                                  onChange={(e) => handleRowSelect(e, order.id)}
                                />
                                <span className="checkmark"></span>
                              </label>
                            </li>
                            <li className="reference">
                              <div className="d-flex accord align-items-center">
                                <h5>{order.reference_number}</h5>
                                {validProducts.length > 1 && (
                                  <div
                                    className="accordion accordion-flush"
                                    id={`accordionFlushExample${order.id}`}
                                  >
                                    <div className="accordion-item">
                                      <button
                                        className="accordion-button "
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapseOne${order.id}`}
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                      ></button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </li>
                            <li className="date">
                              <h5>{order.delivery_date}</h5>
                            </li>
                            <li className="category">
                              <h5>
                                {order?.customer_group?.customer_category
                                  ?.name ||
                                  order?.customer_category?.name ||
                                  ''}
                              </h5>
                            </li>
                            <li className="info">
                              <h5>
                                {order.customer?.name || ''}
                                <br />
                                {order.customer?.code || ''}
                              </h5>
                            </li>
                            <li className="address">
                              <h5>{order.delivery_address || ''}</h5>
                            </li>
                            <li className="district">
                              <h5>{order.district?.name || ''}</h5>
                            </li>
                            <li className="name">
                              <h5> {validProducts[0]?.product_name || ''}</h5>
                            </li>
                            <li className="remark">
                              <h5>{validProducts[0]?.remarks || ''}</h5>
                            </li>
                            <li className="quantity">
                              <h5>
                                {' '}
                                {trimDecimalZero(validProducts[0]?.quantity)}
                              </h5>
                            </li>

                            <li className="payment">
                              <h5>{order.payment_method?.name || ''}</h5>
                            </li>
                            <li className="earliest-time">
                              <h5>
                                {convertTo12HourFormat(
                                  order.earliest_delivery_time
                                ) || '--:--'}
                              </h5>
                            </li>
                            <li className="latest-time">
                              <h5>
                                {convertTo12HourFormat(
                                  order.latest_delivery_time
                                ) || '--:--'}
                              </h5>
                            </li>
                            <li className="contact">
                              <h5>{order.contact_name || ''}</h5>
                              <h5>{order.contact_phone || ''}</h5>
                            </li>
                            <li className="order-remark">
                              <h5>{order.remark || ''}</h5>
                            </li>
                            <li className="update-delivery">
                              <div className="dropdown">
                                {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                                  ?.edit_permission === 1 ? (
                                  <>
                                    <button
                                      className="btn btn-secondary dropdown-toggle"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      {order.delivery_status?.name || ''}
                                    </button>
                                    <ul className="dropdown-menu">
                                      {deliveryStatuses.map((option, i) => (
                                        <li
                                          key={i}
                                          onClick={(e) =>
                                            handleStatusChange(
                                              order.id,
                                              option.id,
                                              'delivery_status'
                                            )
                                          }
                                        >
                                          <a
                                            className={`dropdown-item ${option.id == order.delivery_status?.id ? 'active' : ''}`}
                                          >
                                            {option.name}
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  </>
                                ) : (
                                  order.delivery_status?.name || ''
                                )}
                              </div>
                            </li>
                            <li className="update-status update-delivery">
                              <div className="dropdown">
                                {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                                  ?.edit_permission === 1
                                  ? order.type === 'LOGISTICS' && (
                                      <>
                                        <button
                                          className="btn dropdown-toggle"
                                          type="button"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          {order.status?.name || ''}
                                        </button>
                                        <ul className="dropdown-menu">
                                          {orderStatuses.map((option, i) => (
                                            <li
                                              key={i}
                                              onClick={(e) =>
                                                handleStatusChange(
                                                  order.id,
                                                  option.id,
                                                  'status'
                                                )
                                              }
                                            >
                                              <a
                                                className={`dropdown-item ${option.id == order.status?.id ? 'active' : ''}`}
                                              >
                                                {option.name}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </>
                                    )
                                  : order.status?.name || ''}
                              </div>
                            </li>
                            {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                              ?.edit_permission === 1 && (
                              <li className="action">
                                <div className="action-btn-change">
                                  {order.type === 'LOGISTICS' && (
                                    <button
                                      onClick={() => {
                                        openAddEditModal(order);
                                      }}
                                    >
                                      <img src="images/edit-black.svg" alt="" />
                                    </button>
                                  )}
                                </div>
                              </li>
                            )}
                          </div>
                          {/* <!-- nested list --> */}
                          {validProducts
                            .slice(1)
                            .map((product, productIndex) => (
                              <ul
                                key={productIndex}
                                className="p-0 nested-list-row accordion-collapse collapse show"
                                id={`collapseOne${product.order_id}`}
                                aria-labelledby="headingOne"
                                data-bs-parent="accordionFlushExample"
                              >
                                <div className="d-flex logitcs-flex">
                                  <li className="t-checkbox">
                                    <label className="container"></label>
                                  </li>
                                  <li className="reference"></li>
                                  <li className="date">
                                    <h5>{order.delivery_date}</h5>
                                  </li>
                                  <li className="category">
                                    <h5>
                                      {order?.customer_group?.customer_category
                                        ?.name ||
                                        order?.customer_category?.name ||
                                        ''}
                                    </h5>
                                  </li>
                                  <li className="info">
                                    <h5>
                                      {order.customer?.name || ''}
                                      <br />
                                      {order.customer?.code || ''}
                                    </h5>
                                  </li>
                                  <li className="address">
                                    <h5>{order.delivery_address || ''}</h5>
                                  </li>
                                  <li className="district">
                                    <h5>{order.district?.name || ''}</h5>
                                  </li>
                                  <li className="name">
                                    <h5> {product?.product_name || ''}</h5>
                                  </li>
                                  <li className="remark">
                                    <h5>{product?.remarks || ''}</h5>
                                  </li>
                                  <li className="quantity">
                                    <h5>
                                      {trimDecimalZero(product?.quantity)}
                                    </h5>
                                  </li>

                                  <li className="payment">
                                    <h5>{order.payment_method?.name || ''}</h5>
                                  </li>
                                  <li className="earliest-time">
                                    <h5>
                                      {convertTo12HourFormat(
                                        order.earliest_delivery_time
                                      ) || '--:--'}
                                    </h5>
                                  </li>
                                  <li className="latest-time">
                                    <h5>
                                      {convertTo12HourFormat(
                                        order.latest_delivery_time
                                      ) || '--:--'}
                                    </h5>
                                  </li>
                                  <li className="contact">
                                    <div className="">
                                      <h5>{order.contact_name || ''}</h5>
                                      <h5>{order.contact_phone || ''}</h5>
                                    </div>
                                  </li>
                                  <li className="order-remark">
                                    <h5>{order.remark || ''}</h5>
                                  </li>

                                  <li className="update-delivery"></li>
                                  <li className="update-status"></li>
                                  {permissions?.LOGISTIC_DELIVERY_INFO_HOME_PAGE
                                    ?.edit_permission === 1 && (
                                    <li className="action"></li>
                                  )}
                                </div>
                              </ul>
                            ))}
                        </ul>
                      );
                    })
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <Pagination
          currentPage={pagination.current_page}
          totalPages={pagination.last_page}
          paginate={paginate}
          loading={loading}
        />
        <Modal
          isOpen={addModal}
          onRequestClose={() => setAddEditModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <LogisticsOrderModal
            setAddEditModal={setAddEditModal}
            actionType={modalActionType}
            onSuccess={handleModalSuccess}
            logisticsOrder={selectedOrdersEdit}
          />
        </Modal>
        {/* <AddOrderModal/> */}
        <Modal
          isOpen={importModal}
          onRequestClose={() => setImportModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <ImportOrdersModal
            setImportModal={setImportModal}
            handleImportOrders={handleImportOrders}
            importLoading={importLoading}
            type="LOGISTICS"
          />
        </Modal>
        <Modal
          isOpen={bulkUpdateConfirmationModal}
          onRequestClose={() => setBulkUpdateConfirmationModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <BulkUpdateConfirmationModal
            setConfirmationModal={setBulkUpdateConfirmationModal}
            onSuccess={onSuccessBulkUpdateConfirmation}
            loading={bulkActionLoading}
          />
        </Modal>
      </section>
    </main>
  );
}
